var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("v-flex", { attrs: { md12: "" } }, [
                        _c("h2", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.creacion
                                  ? "Crear Configuración de Autorizaciones"
                                  : _vm.edicion
                                  ? "Editar Configuración de Autorizaciones"
                                  : _vm.visualizacion
                                  ? "Ver Configuración de Autorizaciones"
                                  : ""
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "FormFieldsContainer",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs2: "", sm2: "", md2: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "number",
                              label: "Número de Orden *",
                              disabled:
                                !(_vm.creacion || _vm.edicion) || _vm.inactivo,
                              dense: "",
                              required: ""
                            },
                            on: { input: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.nroOrden,
                              callback: function($$v) {
                                _vm.nroOrden = $$v
                              },
                              expression: "nroOrden"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs2: "", sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Estado",
                              items: _vm.estados,
                              disabled: _vm.creacion || !_vm.edicion
                            },
                            on: { change: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.estadoSelected,
                              callback: function($$v) {
                                _vm.estadoSelected = $$v
                              },
                              expression: "estadoSelected"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              label: "Usuario *",
                              items: _vm.listaUsuarios,
                              "item-text": "nombrecompleto",
                              "item-value": "id",
                              disabled:
                                !(_vm.creacion || _vm.edicion) || _vm.inactivo,
                              dense: "",
                              required: ""
                            },
                            on: { change: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.usuario,
                              callback: function($$v) {
                                _vm.usuario = $$v
                              },
                              expression: "usuario"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", sm4: "", md4: "" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              label: "Operación *",
                              items: _vm.listaOperaciones,
                              "item-text": "configdescripcion",
                              "item-value": "configid",
                              disabled:
                                !(_vm.creacion || _vm.edicion) || _vm.inactivo,
                              dense: "",
                              required: ""
                            },
                            on: { change: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.operacion,
                              callback: function($$v) {
                                _vm.operacion = $$v
                              },
                              expression: "operacion"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        {
                          staticClass: "fle",
                          attrs: { xs12: "", sm12: "", md12: "" }
                        },
                        [
                          _c("v-textarea", {
                            staticClass: "textAreaForm",
                            attrs: {
                              label: "Observación",
                              disabled:
                                !(_vm.creacion || _vm.edicion) || _vm.inactivo,
                              "no-resize": ""
                            },
                            on: { input: _vm.emitirParaGuardar },
                            model: {
                              value: _vm.observacion,
                              callback: function($$v) {
                                _vm.observacion = $$v
                              },
                              expression: "observacion"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }